<div class="dl-page dl-page--narrow">

  <div class="dl-page__heading">
    <a class="dl-page__back" [routerLink]="['/partners', tenantId]">
      <mat-icon>chevron_left</mat-icon>
      Back to partner
    </a>
    <h1 class="dl-page__title">Import data</h1>
    <p class="dl-page__subtitle">Load a practice's existing data into tenant #{{ tenantId }}.</p>
  </div>

  <div class="dl-card">
    <div class="dl-card__body">
    <div class="dl-filters">
      <div class="dl-field">
        <label class="dl-field__label" for="vendor">Coming from</label>
        <select id="vendor" class="dl-select" [(ngModel)]="vendor" (ngModelChange)="onSettingChanged()"
                [disabled]="previewing || importing">
          <option *ngFor="let v of vendors" [value]="v.value">{{ v.label }}</option>
        </select>
      </div>

      <div class="dl-field">
        <label class="dl-field__label" for="entity">What's in the file</label>
        <select id="entity" class="dl-select" [(ngModel)]="entity" (ngModelChange)="onSettingChanged()"
                [disabled]="previewing || importing">
          <option *ngFor="let e of entities" [value]="e.value">{{ e.label }}</option>
        </select>
      </div>
    </div>

    <app-file-upload
      acceptedTypes=".csv,text/csv"
      placeholder="Drag the exported CSV here, or click to choose one"
      [autoUpload]="false"
      [maxSize]="10485760"
      [disabled]="previewing || importing"
      (fileSelected)="onFileSelected($event)"
      (fileRemoved)="onFileRemoved()">
    </app-file-upload>

    <div class="import-actions">
      <button type="button" class="dl-btn dl-btn--primary"
              (click)="preview()"
              [disabled]="!file || previewing || importing">
        {{ previewing ? 'Reading…' : 'Preview' }}
      </button>
      <span class="dl-field__hint" *ngIf="!plan">Nothing is written until you review this and press Import.</span>
    </div>

    <div class="dl-banner dl-banner--error" *ngIf="error">
      <mat-icon>error</mat-icon>
      <div class="dl-banner__body">{{ error }}</div>
    </div>
    <div class="dl-banner dl-banner--success" *ngIf="success">
      <mat-icon>check_circle</mat-icon>
      <div class="dl-banner__body">{{ success }}</div>
    </div>
    </div>
  </div>

  <div class="dl-card" *ngIf="plan">
    <div class="dl-card__header">
      <h2 class="dl-card__title">{{ committed ? 'Imported' : 'Preview' }}</h2>
    </div>
    <div class="dl-card__body">

    <div class="dl-stat-grid import-totals">
      <div class="dl-stat"><span class="dl-stat__value">{{ plan.totals.rows }}</span><span class="dl-stat__label">rows</span></div>
      <div class="dl-stat dl-stat--good"><span class="dl-stat__value">{{ plan.totals.created }}</span><span class="dl-stat__label">new</span></div>
      <div class="dl-stat dl-stat--primary"><span class="dl-stat__value">{{ plan.totals.updated }}</span><span class="dl-stat__label">updated</span></div>
      <div class="dl-stat"><span class="dl-stat__value">{{ plan.totals.unchanged }}</span><span class="dl-stat__label">unchanged</span></div>
      <div class="dl-stat dl-stat--bad" *ngIf="plan.totals.errors"><span class="dl-stat__value">{{ plan.totals.errors }}</span><span class="dl-stat__label">errors</span></div>
    </div>

    <div class="dl-banner dl-banner--info" *ngIf="plan.newCategories.length"><div class="dl-banner__body">
      <strong>New categories ({{ plan.newCategories.length }}):</strong>
      {{ plan.newCategories.join(', ') }}
    </div></div>

    <div class="dl-banner dl-banner--warning" *ngIf="plan.unmappedColumns.length"><div class="dl-banner__body">
      <strong>Not imported:</strong>
      {{ plan.unmappedColumns.join(', ') }} — Dental Link has nowhere to put these columns yet.
    </div></div>

    <div class="dl-banner dl-banner--warning" *ngIf="plan.issues.length"><div class="dl-banner__body">
      <strong>File issues:</strong>
      <ul>
        <li *ngFor="let issue of plan.issues">
          <span *ngIf="issue.line">Line {{ issue.line }}: </span>{{ issue.message }}
        </li>
      </ul>
    </div></div>

    <div class="dl-banner dl-banner--error" *ngIf="blocked"><div class="dl-banner__body">
      {{ plan.totals.errors }} row(s) cannot be imported, so the file is refused as a whole. Fix
      them in the export and upload it again.
    </div></div>

    <div class="import-actions" *ngIf="!committed">
      <button type="button" class="dl-btn dl-btn--primary"
              (click)="runImport()"
              [disabled]="blocked || importing">
        {{ importing ? 'Importing…' : 'Import ' + plan.totals.rows + ' row(s)' }}
      </button>
    </div>

    </div>

    <table class="dl-table dl-table--cards" dlCardTable>
      <thead>
        <tr>
          <th>Line</th>
          <th>Code</th>
          <th>Name</th>
          <th>Category</th>
          <th>Price</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of sortedRows; trackBy: trackByLine"
            [class.row-error]="row.action === 'ERROR'">
          <td class="dl-cell--hide-sm">{{ row.line }}</td>
          <td>{{ row.code || '—' }}</td>
          <td class="dl-cell--title">
            {{ row.name }}
            <div class="row-message" *ngIf="row.message">{{ row.message }}</div>
          </td>
          <td>{{ row.category || '—' }}</td>
          <td>{{ row.price | number:'1.2-2' }}</td>
          <td><span class="import-badge" [ngClass]="badgeClass(row.action)">{{ row.action }}</span></td>
        </tr>
      </tbody>
    </table>
  </div>

</div>
